<div *ngIf="showDisclaimerForDataResult()">
    <span>
        <b>
        {{this.loadDisclaimerForDataResult()}}
        </b>
    </span>
</div>
